// Homepage embedded images - workaround for CDN SSL issue
export const HERO_BEFORE = '/img/home-hero_before.webp';
export const HERO_AFTER = '/img/home-hero_after.webp';